var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("entity-filter", {
        staticClass: "mb-n1",
        attrs: {
          isLoading: _vm.isLoading,
          useEvents: _vm.useEvents,
          teams: _vm.teams,
          hideStatus: _vm.isArchive,
          eventsValues: _vm.eventsValues,
          eventsLabel: _vm.eventsLabel,
          "select-all-events": _vm.selectAllEvents
        },
        on: { change: _vm.filterChange }
      }),
      _vm._t(
        "currentList",
        function() {
          return [
            _c("v-data-table", {
              staticClass: "elevation-1",
              attrs: {
                headers: _vm.headers,
                items: _vm.filteredEntities,
                "items-per-page": 15,
                dense: "",
                search: _vm.searchTerm,
                "footer-props": {
                  showFirstLastPage: true,
                  itemsPerPageOptions: [-1, 10, 15, 20, 25],
                  firstIcon: "mdi-arrow-collapse-left",
                  lastIcon: "mdi-arrow-collapse-right",
                  prevIcon: "mdi-minus",
                  nextIcon: "mdi-plus"
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: `item.name`,
                    fn: function({ item }) {
                      return [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: _vm.readRoute,
                                params: { id: item.keyId }
                              },
                              title: item.name
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.name ? item.name : "[NO NAME]") +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: `item.archiveDate`,
                    fn: function({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("luxonSortableDateTime")(item.archiveDate)
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          ]
        },
        {
          entities: _vm.filteredEntities,
          searchTerm: _vm.searchTerm,
          readRoute: _vm.readRoute
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }